export default {
  legalformList: [
    {"name": "AG", "code": "AG"},
    {"name": "e.G.", "code": "e.G."},
    {"name": "Einzelfirma", "code": "Einzelfirma"},
    {"name": "e.K.", "code": "e.K."},
    {"name": "Freiberufler", "code": "Freiberufler"},
    {"name": "GbR", "code": "GbR"},
    {"name": "GmbH", "code": "GmbH"},
    {"name": "GmbH & Co. KG", "code": "GmbH & Co. KG"},
    {"name": "KG", "code": "KG"},
    {"name": "KG aA", "code": "KG aA"},
    {"name": "OHG", "code": "OHG"},
    {"name": "UG", "code": "UG"}
  ],
  other: {"name": "-- Sonstiges --", "code": "0000"}
};
